import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "ProposalAttachment/";

const getProposalAttachment = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProposalAttachment?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getProposalAttachments = async (proposalId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProposalAttachments?proposalId=' + proposalId, constants.REQUIRE_INTERCEPTORS);

const saveProposalAttachment = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveProposalAttachment', model, { ... constants.REQUIRE_INTERCEPTORS, fileHandler: true});

const deleteProposalAttachment = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteProposalAttachment?id=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getProposalAttachment,
    getProposalAttachments,
    saveProposalAttachment,
    deleteProposalAttachment,
}